import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/home/pages/home-page/home-page.component').then(
        (m) => m.HomePageComponent
      ),
    data: { title: 'Home' },
  },
  {
    path: 'homes',
    loadChildren: () =>
      import('./features/homes/homes.module').then((m) => m.HomesModule),
    data: { title: 'Homes' },
  },
  {
    path: 'products',
    loadChildren: () =>
      import('./features/products/products.module').then(
        (m) => m.ProductsModule
      ),
    data: { title: 'Products' },
  },
  {
    path: 'about',
    loadChildren: () =>
      import('./features/about/about.module').then((m) => m.AboutModule),
    data: { title: 'About' },
  },
  {
    path: 'contact',
    loadChildren: () =>
      import('./features/contact/contact.module').then((m) => m.ContactModule),
    data: { title: 'Contact' },
  },
  {
    path: 'blog',
    loadChildren: () =>
      import('./features/blog/blog.module').then((m) => m.BlogModule),
    data: { title: 'Blog' },
  },
  {
    path: '**',
    redirectTo: '',
  },
];
